<template>
  <div>
    <h1 class="page-header">Screen {{ machineSerial.toUpperCase() }}</h1>
    <div v-if="machine" class="row">
      <div class="col-md-4">
        <machine-info :machine="machine" @baseFileEdit="baseFileEdit"></machine-info>
      </div>
      <div class="col-md-8">
        <machine-life-cycle :machine="machine" @machineUpdated="fetchMachine"></machine-life-cycle>
      </div>
    </div>
    <div v-else class="text-center">
      <span v-if="errorText">{{ errorText }}</span>
      <b-spinner v-else label="Loading..." show variant="secondary"></b-spinner>
    </div>
  </div>
</template>

<script>
import machineInfo from '@/components/MachineInfo.vue'
import machineLifeCycle from '@/components/MachineLifeCycle.vue'
import { machinesApi } from '@/backend'

export default {
  name: 'MachinePage',
  components: {
    machineInfo,
    machineLifeCycle
  },
  data () {
    return {
      machine: null,
      errorText: null
    }
  },
  mounted () {
    this.fetchMachine()
  },
  computed: {
    machineSerial: function () {
      return this.$route.params.serial
    }
  },
  watch: {
    $route: {
      handler: function (to) {
        if (to.name === 'machine' && to.params.serial !== undefined) {
          this.fetchMachine(to.params.serial)
        }
      }
    }
  },
  methods: {
    fetchMachine: function (serial) {
      const serialToFetch = serial || this.machineSerial
      machinesApi.getMachine(serialToFetch, (error, data) => {
        if (error) {
          if (error.status === 404) {
            this.errorText = `Machine serial number '${serialToFetch}' could not be found in ScreenCheck Portal.`
          } else {
            this.errorText = error.response.body.message || 'Failed fetching machine data'
          }
          console.error('Failed fetching machine because: ' + error)
          return
        }
        this.machine = data
        this.errorText = null
      })
    },
    baseFileEdit: function (newSerial) {
      this.$router.push({ name: 'machine', params: { serial: newSerial } }).catch(() => {})
      this.fetchMachine(newSerial)
    }
  }
}
</script>

<style lang="scss">
</style>